export default __webpack_public_path__ + "d1650b5754f9305d502768e04e738d4d.png";